<template>
  <v-app>
    <dashboard-core-drawer :expand-on-hover="expandOnHover" />
    <dashboard-core-app-bar :image="headerImage.getByEnvironment()" />
    <dashboard-core-view />
    <dashboard-core-footer />
  </v-app>
</template>

<script>
  import Configuration from '@/utilities/service/Configuration'
  import HeaderImage from '@/utilities/helper/HeaderImage'

  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      DashboardCoreDrawer: () => import('./components/core/Drawer'),
      DashboardCoreView: () => import('./components/core/View'),
      DashboardCoreFooter: () => import('./components/core/Footer'),
    },
    data: () => ({
      expandOnHover: false,
      images: {
        dev: '/images/opus-logo-header.png',
        uat: '/images/opus-logo-header-uat.png',
        qa: '/images/opus-logo-header-qa.png',
        prod: '/images/opus-logo-header.png',
      },
    }),
    computed: {
      headerImage: vm => new HeaderImage(vm.images, Configuration.value('version')),
    },
    beforeMount() {
      // Reload protection
      if (Configuration.value('version') === 'Development') {
        return
      }
      window.addEventListener('beforeunload', this.preventNav)
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('beforeunload', this.preventNav)
      })
    },
    methods: {
      preventNav(event) {
        event.preventDefault()
        event.returnValue = ''
      },
    },
  }
</script>
